<template>
	<div class="search-cols">
		<div class="search-cols-title">
			<div>Columns</div>
			<CloseIcon class="close-icon" @click="onClose()"/>
		</div>
		<div :class="`search-cols-button ${isActive ? 'button-abled': 'button-disabled'}`" @click="onSaveChanges">Save Changes</div>
		<div :class="$vuetify.breakpoint.mdAndUp ? 'search-cols-content-sm':'search-cols-content'">
			<div class="content-item">
				<div class="content-sub-item">
					Job Information
					<v-checkbox v-for="item in columns_info" :key="item.value"
						v-model="selected_local"
						color="info"
						:label="item.text"
						:value="item"
					></v-checkbox>
				</div>
				<div class="content-sub-item">
					Client
					<v-checkbox v-for="item in columns_client" :key="item.value"
						v-model="selected_local"
						color="info"
						:label="item.text"
						:value="item"
					></v-checkbox>
				</div>
				<div class="content-sub-item">
					Team
					<v-checkbox v-for="item in columns_team" :key="item.value"
						v-model="selected_local"
						color="info"
						:label="item.text"
						:value="item"
					></v-checkbox>
				</div>
			</div>
			<div class="content-item" :style="financialsPrivilege? '':'color: rgba(196, 196, 196, 1)'">
				<div class="content-sub-item">
					Budget
					<v-checkbox v-for="item in columns_budget" :key="item.value"
						v-model="selected_local"
						color="info"
						:value="item"
						:disabled="!financialsPrivilege"
					>
						<template v-slot:label>
							<span :style="financialsPrivilege? '':'color: rgba(196, 196, 196, 1)'">{{ item.text }}</span>
						</template>
					</v-checkbox>
				</div>
				<div class="content-sub-item">
					Billings
					<v-checkbox v-for="item in columns_billings" :key="item.value"
						v-model="selected_local"
						color="info"
						:label="item.text"
						:value="item"
						:disabled="!financialsPrivilege"
					>
						<template v-slot:label>
							<span :style="financialsPrivilege? '':'color: rgba(196, 196, 196, 1)'">{{ item.text }}</span>
						</template>
					</v-checkbox>
				</div>
			</div>
		</div>
		<v-dialog
			v-model="dialog"
			persistent
			max-width="400"
		>
			<v-alert
				border="top"
				color="#FFB946"
				colored-border
			>
				<div class="alert">
					<div class="alert-title">Unsaved changes?</div>
					<div class="alert-content">You have unsaved changes in your worklist. Do you want to save them? </div>
					<div class="alert-button">
						<div @click="dialog = false" >
							CANCEL
						</div>
						<div @click="onSaveChanges" >
							SAVE CHANGES
						</div>
					</div>
				</div>
			</v-alert>
		</v-dialog>
	</div>
</template>
<script>
import CloseIcon from '@/components/icons/close';
import config from '@/config.js';

const columns_info = [
	{
		text: config.table_title.number,
		value: 'code',
	},
	{
		text: config.table_title.title,
		value: 'short',
	},
	{
		text: config.table_title.type,
		value: 'job_type',
	},
	{
		text: config.table_title.status,
		value: 'status',
	}

	// config.table_title.number, 
	// config.table_title.title, 
	// config.table_title.type, 
	// config.table_title.status
];

const columns_client = [
	{
		text: config.table_title.client,
		value: 'client',
	},
	{
		text: config.table_title.division,
		value: 'division',
	},
	// config.table_title.client,
	// config.table_title.division,
];

const columns_team = [
	{
		text: config.table_title.acc_executive,
		value: 'acc_exec',
	},
	{
		text: config.table_title.acc_director,
		value: 'acc_dir',
	},
	// config.table_title.acc_executive,
	// config.table_title.acc_director,
];

const columns_budget = [
	{
		text: config.table_title.total_value,
		value: 'total_value',
	}
	// config.table_title.total_value
];

const columns_billings = [
	{
		text: config.table_title.budget_used,
		value: 'perc_quoted_billed',
	},
	{
		text: config.table_title.total_invoiced,
		value: 'total_invoiced',
	},
	{
		text: config.table_title.value_billed,
		value: 'perc_value_billed',
	},
	{
		text: config.table_title.traffic_used,
		value: 'perc_traffic_used',
	}
	// config.table_title.budget_used,
	// config.table_title.total_invoiced,
	// config.table_title.value_billed,
	// config.table_title.traffic_used,
];

export default {
	name: 'SearchColsFilter',
	props: {
		selected: {
			type: Array,
			default: () => [],
		},
		financialsPrivilege: {
			type: Boolean,
			default: true
		}
	},
	components: {
		CloseIcon,
	},
	data() {
		return {
			selected_local: [],
			isActive: false,
			dialog: false,
			columns_info: columns_info,
			columns_client: columns_client,
			columns_team: columns_team,
			columns_budget: columns_budget,
			columns_billings: columns_billings,
		}
	},
	async created() {
		this.deepCopySelected();
	},
	watch: {
		selected_local() {
			if (this.selected_local.length !== this.selected.length) {
				this.isActive = true;
			} else {
				this.isActive = !this.isEqualSelected();
			}
		},
	},
	methods: {
		onClose() {
			if (this.isActive) {
				this.dialog = true;
			} else {
				this.$emit('close', null);
			}
		},
		onSaveChanges() {
			this.dialog = false;
			this.$emit('close', this.selected_local);
		},
		deepCopySelected() {
			this.selected.forEach(e => {
				this.selected_local.push(e);
			});
		},
		isEqualSelected() {
			let isEqual = true;
			const A = [];
			const B = [];

			this.selected_local.forEach(e => {
				A.push(e.value)
			});
			this.selected.forEach(e => {
				B.push(e.value)
			});
        
			A.sort();
			B.sort();

			for (let index = 0; index < A.length; index++) {
				if (A[index] !== B[index]) {
					isEqual = false;
				}
			}
			return isEqual;
		},
	}
}
</script>
<style lang="scss" scoped>
.search-cols {
  height: 100%;
  padding: 12px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  background: #FFFFFF;
  border-radius: 4px;
}
.search-cols-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 36px;
  color: rgba(0, 0, 0, 0.87);
}
.close-icon {
  width: 18px;
  height: 18px; 
  &:hover {
    cursor: pointer;
  }
}
.search-cols-button {
  width: 100%;
  height: 32px;
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  letter-spacing: 0.4px;
  border-radius: 4px;
}
.button-abled {
  background: #00AAFD;
  border: 1px solid #00AAFD;
  color: #FFFFFF;
  &:hover {
    cursor: pointer;
  }
}
.button-disabled {
  background: #FFFFFF;
  border: 1px solid rgba(25, 42, 62, 0.7);
  color: #192A3E;
}
.search-cols-content {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 24px;
}
.search-cols-content-sm {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 6px;
}
.content-item {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #192A3E;
}
.content-sub-item {
  margin-bottom: 13px;
}
.alert {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  .alert-title {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    margin-bottom: 14px;
  }
  .alert-content {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.4px;
    color: #000000;
  }
  .alert-button {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 36px;
    border-radius: 4px;
    text-align: center;
    padding: 22px 0 11px 0;
    :first-child {
      width: 88px;
      height: 36px;
      border: 1px solid rgba(25, 42, 62, 0.7);
      border-radius: 4px;
      box-sizing: border-box;
      margin-right: 10px;
      color: rgba(25, 42, 62, 0.7);
      &:hover {
        cursor: pointer;
      }
    }
    :last-child {
      width: 126px;
      height: 36px;
      background: #00AAFD;
      border: 1px solid #00AAFD;
      border-radius: 4px;
      color: #FFFFFF;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.v-alert {
  margin-bottom: 0;
}

.v-input--selection-controls {
  margin: 10px 0;
  padding: 0;
  height: 18px;
}
.v-input__control {
  height: 18px;
}
::v-deep {
  .v-input--selection-controls .v-input__slot > .v-label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #192A3E;
  }
}

</style>